import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1w whitespace-nowrap rounded text-sm ring-offset-white transition-colors disabled:pointer-events-none",
  {
    variants: {
      variant: {
        default: "bg-admin-blue-300 text-white hover:bg-admin-blue-400 active:bg-admin-blue-500 disabled:bg-admin-blue-100",
        secondary: "border bg-white border-admin-blue-300 text-admin-blue-300 hover:bg-admin-blue-100 hover:text-admin-blue-400 hover:border-admin-blue-400 active:bg-admin-blue-200 active:text-admin-blue-400 active:border-admin-blue-400 disabled:text-admin-blue-100 disabled:border-admin-blue-100",
        text: "bg-white text-admin-blue-300 hover:bg-admin-blue-100 hover:text-admin-blue-400 active:bg-admin-blue-200 active:text-admin-blue-400 disabled:text-admin-blue-100",
      },
      size: {
        default: "px-3w py-1w",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
